import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
    setSaveStatus,
    setInitLocationBase,
    setUsePlanAareaId
} from "../../features/longPageSlice";
import { upsertlocationBaseParam, locationBaseData } from "../components/LocationBaseFunc";
import { upsertLocationAddSurvey } from "../components/LocationAddSurveyFunc";
import { upsertCoverParam } from "../subPage/Cover/CoverFunction";
import { upsertStoreOpeningConditionsParam } from "../subPage/StoreOpeningConditions/StoreOpeningConditionsFunction";
import { upsertTradeAreaParam } from "../subPage/TradeArea/TradeAreaFunction";
import { upsertPhotoParam } from "../subPage/Pictuer/PhotoFunction";
import {
    upsertLocationTraffic5mcutParam,
    setParam,
    carPeopleParamCheck
} from "../subPage/TrafficVolume/TrafficVolumeFunction";
import { upsertLocationConflictMarketCut } from "../subPage/Conflict/AddConflictFunction";
import { upsertLocationImpact } from "../subPage/Impact/AddImpactFunction";
import { upsertDonationParam } from "../subPage/Donation/DonationFunction";
import { upsertDrawingParam } from "../subPage/Drawing/DrawingFunction";
import {
    Box,
    Button,
    Grid,
    styled,
    createTheme,
    Dialog,
    DialogTitle
} from "@mui/material";
import { LOCAL_CONSTANT } from "../Const";
import { useNavigate } from "react-router-dom";
import { useUtilityContext } from "../../utility-provider";
import { useUserContext } from "../../user-provider";
import { encryptQueryParam } from "../../utility/util";
import { apiRequest } from "../../api/ApiCall";
import { updateListRegist } from "../Common";
import { HideShowFunc } from "../components/PermissionFunc";
import InvalidInputList from "../components/InvalidInputList";
import LocationExcelAndN15AddMarktCheck from "../components/LocationExcelAndN15AddMarktCheck";
import { setObjEditImpactData } from "../../features/impactSlice";
import {
    setReduxReloadTrafficVolume,
    setTrafficVolumeClearDeleteParam,
} from "../../features/trafficVolumeSlice";
import { userLogging } from "../../utility/firestore";
import { getLongPageData } from "../../data/DataManage";
import {
    setObjStoreOpeningConditions,
    setInitObjStoreOpeningConditions
} from "../../features/storeOpeningConditionsSlice";
import { storeOpeningConditionsData } from "../subPage/StoreOpeningConditions/StoreOpeningConditionsFunction";
import TrafficCheckModal from "../components/TrafficCheckModal";

//スタイル
const FloatButton = styled(Button)({
    backgroundColor: "#FFFFFF",
    color: "#0E6F55",
    border: "solid 1px #00AC4C",
    marginLeft: "10px",
    "&: hover": {
        backgroundColor: "#F0F0F0",
        borderColor: "#00AC4C"
    },
});
const FloatRedButton = styled(Button)({
    backgroundColor: "#FFFFFF", // 背景色を白に変更
    color: "#FF0000", // テキスト色を赤に変更
    border: "solid 1px #FF0000", // ボーダー色を赤に変更
    marginLeft: "10px",
    "&: hover": {
        backgroundColor: "#F0F0F0",
        borderColor: "#FF0000"
    },
});
const theme = createTheme({
    spacing: 4,
});
const CancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
    float: "left",
    margin: "10px 20px",
});
const SaveButton = styled(Button)({
    backgroundColor: "#00CC5B",
    color: "white",
    float: "right",
    margin: "10px 20px",
    "&: hover": {
        backgroundColor: "#29e17a",
    },
});
const DuplicateCancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
    float: "left",
    margin: "10px",
});
const DuplicateButton = styled(Button)({
    backgroundColor: "#00CC5B",
    color: "white",
    float: "right",
    margin: "10px",
    "&: hover": {
        backgroundColor: "#29e17a",
    },
});

// 不備コメントがあるページのテーブル名を表示順に並び替える順序リスト
const deficiencyPageOrder = [
    LOCAL_CONSTANT.TABLE.COVER,
    LOCAL_CONSTANT.TABLE.STORE_OPENING_CONDITIONS,
    LOCAL_CONSTANT.TABLE.TRADE_AREA,
    LOCAL_CONSTANT.TABLE.PICTURE,
    LOCAL_CONSTANT.TABLE.DONATION,
    LOCAL_CONSTANT.TABLE.TRAFFIC,
    LOCAL_CONSTANT.TABLE.CONFLICT,
    LOCAL_CONSTANT.TABLE.IMPACT,
    LOCAL_CONSTANT.TABLE.MAP,
    LOCAL_CONSTANT.TABLE.DRAWING
];

type ElementIds = {
    [key: string]: string;
};

// 不備コメントがあるページのテーブル名と対応するスクロール要素のIDをマッピング
const elementIds: ElementIds = {
    location_cover: "CoverId",
    location_storeopeningconditions: "StoreOpeningConditionsId",
    location_trade_area: "TradeAreaId",
    location_pictuer: "PictureId",
    location_donation: "DonationId",
    location_traffic: "TrafficVolumeId",
    location_conflict: "ConflictId",
    location_impact: "ImpactId",
    location_map: "MapId",
    location_drawing: "DrawingId"
};

export interface menuProps {
    props: {
        planAreaId: string | null;
        branch: string | null;
        excelSequence: string | null;
    };
}
const Menu: React.FC<menuProps> = ({ props }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const user = useUserContext();

    //ロングページ保存用ステータス
    const objLongPageSaveStatus = useAppSelector((state) => state.longPage.saveStatus);
    // 複製店舗、候補地ID
    const objStorePlanAreaId = useAppSelector((state) => state.longPage.storePlanAreaId);
    // 単体保存ステータス
    const objUnitEdit = useAppSelector((state) => state.longPage.unitEdit);
    // 調査書テーブル
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);
    //追加調査を取得
    const objLocationAddSurvey = useAppSelector((state) => state.locationAddSurvey.obj);
    // 表紙
    const objCover = useAppSelector((state) => state.cover.obj);
    // 出店条件
    const objStoreOpeningConditions = useAppSelector((state) => state.storeOpeningConditions.obj);
    // 商圏
    const listTradeArea = useAppSelector((state) => state.tradeArea.mpDataList);
    // 現況写真
    const objPicture = useAppSelector((state) => state.picture);
    // 寄付き
    const objDonation = useAppSelector((state) => state.donation.obj);
    // 通行量 車通行量、人通行量
    const listUpdateTraffic = useAppSelector((state) => state.trafficVolume.updateList);
    // 通行量 削除パラメータ
    const listDeleteTrafficParam = useAppSelector((state) => state.trafficVolume.deleteParamterList);
    // 通行量(5m外歩行者TR算入確認)
    const objLocationTraffic5mcut = useAppSelector((state) => state.locationTraffic5mcut.obj);
    // 通行量 その他 駅出入口の名称と距離
    const objStation = useAppSelector((state) => state.locationTraffic5mcut.stationObj);
    // 通行量 その他 大学短大の名称と距離
    const objSchool = useAppSelector((state) => state.locationTraffic5mcut.schoolObj);
    // 競合店（商圏カット）
    const objConflictMarketCut = useAppSelector((state) => state.conflict.market_cut);
    // 影響度
    const objEditImpactData = useAppSelector((state) => state.impact.editImpactData);
    // 図面
    const objDrawing = useAppSelector((state) => state.drawing.obj);
    // 不備コメントリスト
    const listDeficiencyComment = useAppSelector((state) => state.deficiencyComment);
    //既存店ボタン この既存店NOが調査書で使用する候補地IDを取得
    const usePlanAareaId = useAppSelector((state) => state.longPage.usePlanAareaId);
    //モーダル開閉フラグ(保存確認モーダル)
    const [saveConfModalOpen, setSaveConfModalOpen] = useState(false);
    //モーダルページ切替(保存ボタン用)
    const [pageing, setPageing] = useState<number>(0);
    //モーダル開閉フラグ(複製確認モーダル)
    const [duplicateConfModalOpen, setDuplicateConfModalOpen] = useState<boolean>(false);
    //モーダルページ切り替え(複製ボタン用)
    const [duplicatePageing, setDuplicatePageing] = useState<string>("duplicateConfirm");
    //不正な入力項目
    const [errorList, setErrorList] = useState<any>();
    //中間生成物フラグ
    const [locationExcelFlag, setLocationExcelFlag] = useState<string>("");
    //n15追加商圏フラグ
    const [n15AddMarketFlag, setN15AddMarketFlag] = useState<string>("");
    //ユーザー格納
    const [userType, setUserType] = useState<string>("");
    //不備ページ移動ボタンクリックカウント
    const [deficiencyClickCount, setDeficiencyClickCount] = useState(0);
    //不備コメントがあるページ並び替え後のリスト
    const [deficiencySortedList, setDeficiencySortedList] = useState<string[]>([]);
    //複製のステータス
    const [duplicateStatus, setDuplicateStatus] = useState<boolean>(false);
    //通行量項目チェックモーダル
    const [trafficCheckOpen, setTrafficCheckOpen] = useState<boolean>(false);
    
    //保存ボタン活性化
    const hasSaveDisabled = () => {
        let disabled = true;
        // objLongPageSaveStatusが全てfalseならtrueを返す
        const longPageSaveStatus = Object.values(objLongPageSaveStatus).every(
            (value) => value === false
        );
        // objUnitEditが1つでもtrueならtrueを返す
        const unitEdit = Object.values(objUnitEdit).some(
            (value) => value === true
        );
        if (!longPageSaveStatus && !unitEdit) {
            disabled = false;
        }
        return disabled;
    };

    //モーダルクローズ(保存確認モーダル)
    const handleSaveConfModalClose = () => {
        setSaveConfModalOpen(false);
        setTimeout(() => {
            setPageing(0);
        }, 500);
    };

    //モーダルクローズ(複製確認モーダル)
    const hanldeDuplicateConfModalClose = () => {
        setDuplicateConfModalOpen(false);
        setTimeout(() => {
            setDuplicatePageing("duplicateConfirm");
        }, 500);
    };

    // 保存と複製を実施する前に通行量項目チェック
    const handleTrafficCheck = (checkPoint: string) => {
        let checkPointFlag = false;
        // 通行量項目チェック
        checkPointFlag = carPeopleParamCheck(props.planAreaId, listUpdateTraffic);

        switch (checkPoint) {
            case "save":
                if (checkPointFlag) {
                    setTrafficCheckOpen(true);   // 通行量項目チェックモーダルを開く
                    setSaveConfModalOpen(false); // 保存確認モーダルを閉じる
                } else {
                    setTrafficCheckOpen(false);  // 通行量項目チェックモーダルを閉じる
                    setSaveConfModalOpen(true);  // 保存確認モーダルを開く
                }
                break;
            case "dulicate":
                if (checkPointFlag) {
                    setTrafficCheckOpen(true);        // 通行量項目チェックモーダルを開く
                    setDuplicateConfModalOpen(false); // 複製確認モーダルを閉じる
                } else {
                    setTrafficCheckOpen(false);       // 通行量項目チェックモーダルを閉じる
                    setDuplicateConfModalOpen(true);  // 複製確認モーダルを開く
                }
                break;        
            default:
                break;
        };
    };

    //保存用のparams
    const saveParams = () => {
        const params: any = [];
        // 調査書基本
        if (objLongPageSaveStatus.LongPage) {
            params.push(upsertlocationBaseParam(objLocationBase, props.planAreaId, props.branch));
        }
        // 追加調査
        if (objLongPageSaveStatus.AddSurvey) {
            params.push(upsertLocationAddSurvey(objLocationAddSurvey, props.planAreaId, props.branch));
        }
        // 表紙
        if (objLongPageSaveStatus.Cover) {
            params.push(upsertCoverParam(objCover, props.planAreaId, props.branch));
        }
        // 出店条件
        if (objLongPageSaveStatus.StoreOpeningConditions) {
            params.push(upsertStoreOpeningConditionsParam(objStoreOpeningConditions, props.planAreaId, props.branch));
        }
        // 商圏
        if (objLongPageSaveStatus.TradeArea) {
            params.push(upsertTradeAreaParam(listTradeArea, props.planAreaId, props.branch, props.excelSequence));
        }
        // 現況写真
        if (objLongPageSaveStatus.Picture) {
            params.push(upsertPhotoParam(objPicture, props.planAreaId, props.branch));
        }
        // 寄付き
        if (objLongPageSaveStatus.Donation) {
            params.push(
                upsertDonationParam(objDonation, props.planAreaId, props.branch)
            );
        }
        // 通行量
        if (objLongPageSaveStatus.TrafficVolume) {
            params.push(upsertLocationTraffic5mcutParam(objLocationTraffic5mcut, props.planAreaId, props.branch, objStation, objSchool));
        }
        // 通行量 車通行量、人通行量
        if (objLongPageSaveStatus.TrafficVolumeCarPeople) {
            params.push(setParam(props.planAreaId, listUpdateTraffic));
        }
        // 競合　商圏カット
        if (objLongPageSaveStatus.ConflictMarketCut) {
            params.push(upsertLocationConflictMarketCut(objConflictMarketCut, props.planAreaId, props.branch));
        }
        // 影響度
        if (objLongPageSaveStatus.Impact) {
            params.push(upsertLocationImpact(objEditImpactData, props.planAreaId, props.branch));
            // 影響度編集クリア
            dispatch(setObjEditImpactData([]));
        }
        // 図面
        if (objLongPageSaveStatus.Drawing) {
            params.push(upsertDrawingParam(objDrawing, props.planAreaId, props.branch));
        }
        return params;
    };

    //保存ボタン
    const handleSave = () => {
        const params = saveParams();
        // 通行量 削除パラメータもある場合
        if (params.length > 0 || listDeleteTrafficParam.length > 0) {
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner();
            }
            // userLogging
            userLogging(
                LOCAL_CONSTANT.FUNCTION_NAME.LOCATION_SAVE,
                params,
                user
            );
            updateListRegist(params)
                .then(() => {
                    dispatch(
                        setSaveStatus({
                            ...objLongPageSaveStatus,
                            LongPage: false,
                            AddSurvey: false,
                            Cover: false,
                            StoreOpeningConditions: false,
                            TradeArea: false,
                            Picture: false,
                            Donation: false,
                            TrafficVolume: false,
                            TrafficVolumeCarPeople: false,
                            Conflict: false,
                            ConflictMarketCut: false,
                            Impact: false,
                            Map: false,
                            Drawing: false,
                        })
                    );
                })
                .then(() => {
                    // 通行量のReduxを更新
                    dispatch(setReduxReloadTrafficVolume(listUpdateTraffic));
                    // 通行量 削除パラメータもある場合
                    if (listDeleteTrafficParam.length > 0) {
                        userLogging(
                            LOCAL_CONSTANT.FUNCTION_NAME.LOCATION_SAVE_DELETE_TRAFFIC,
                            params,
                            user
                        );
                        updateListRegist(listDeleteTrafficParam);
                    }
                })
                .then(() => {
                    // 通行量 削除パラメータを初期化
                    dispatch(setTrafficVolumeClearDeleteParam());
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                    setPageing(1);
                })
                .catch((e) => {
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                    setPageing(2);
                    console.log(e);
                });
        } else {
            setTimeout(() => {
                setPageing(1);
            }, 500);
        }
    };

    //別タブ遷移
    const handleNewTabPage = (location: string) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        let baseUrl = "";
        let newTabUrl = "";
        let param ="";
        if (location === "/r_view") {
            let planAreaId = props.planAreaId;
            if (objStorePlanAreaId !== "") {
                planAreaId = objStorePlanAreaId;
            }
            baseUrl = process.env.REACT_APP_RECRUIT_VIEW!;
            newTabUrl = `${baseUrl}?mode=detail_prop_site&id=${planAreaId}&encryptionFlag=0`;
            window.open(newTabUrl);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        } else {
            baseUrl = window.location.origin;
            param = `planAreaId=${props.planAreaId}&branch=${props.branch}`;
            // URLクエリパラメータ暗号化
            encryptQueryParam(param).then((res) => {
                newTabUrl = `${baseUrl}${location}?` + res;
                window.open(newTabUrl);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }).catch((e:any) => {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            });
        }
    };

    //別タブで調査書画面を開く
    const handleOpenNewLocationClick = (
        use_plan_area_id: String,
        branch: String | null
    ) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        const baseUrl = window.location.origin;
        const param = `planAreaId=${use_plan_area_id}&branch=${branch}`;
        // URLクエリパラメータ暗号化
        encryptQueryParam(param).then((res) => {
            const newTabUrl = `${baseUrl}/LongPage?` + res;
            window.open(newTabUrl);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    //複製ボタン押下後、既存店ボタン use_plan_area_idと出店条件を取得するAPI
    const callApiDuplicate = async (target: string) => {
        const param: any = [];
        if (target === "getDuplicate") {
            param.push({
                mode: "getLocationBase",
                plan_area_id: props.planAreaId,
                branch: props.branch,
            });
            if (objLocationBase.child_location !== "") {
                param.push({
                    mode: "getExistingSejStoreUsePlanAreaId",
                    plan_area_id: props.planAreaId,
                    branch: props.branch,
                    child_location: objLocationBase.child_location,
                });
            }
            param.push({
                mode: "getLocationStoreOpeningConditions",
                plan_area_id: props.planAreaId,
                branch: props.branch,
            });
            return await getLongPageData(param);
        }
    };

    //複製ボタン
    const handleDuplicate = () => {
        // 通行量項目チェック
        if (carPeopleParamCheck(props.planAreaId, listUpdateTraffic)) {
            setTrafficCheckOpen(true);
            return;
        }
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        //保存処理 項目内容に変更がない場合は保存処理を実施しない
        const params = saveParams();
        // 通行量 削除パラメータもある場合
        if (params.length > 0 || listDeleteTrafficParam.length > 0) {
            userLogging(
                LOCAL_CONSTANT.FUNCTION_NAME.DUPLICATE_SAVE,
                params,
                user
            );
            updateListRegist(params)
                .then(() => {
                    dispatch(
                        setSaveStatus({
                            ...objLongPageSaveStatus,
                            LongPage: false,
                            AddSurvey: false,
                            Cover: false,
                            StoreOpeningConditions: false,
                            TradeArea: false,
                            Picture: false,
                            Donation: false,
                            TrafficVolume: false,
                            TrafficVolumeCarPeople: false,
                            Conflict: false,
                            ConflictMarketCut: false,
                            Impact: false,
                            Map: false,
                            Drawing: false,
                        })
                    );
                })
                .then(() => {
                    // 通行量のReduxを更新
                    dispatch(setReduxReloadTrafficVolume(listUpdateTraffic));
                    // 通行量 削除パラメータもある場合
                    if (listDeleteTrafficParam.length > 0) {
                        userLogging(
                            LOCAL_CONSTANT.FUNCTION_NAME.DUPLICATE_SAVE_DELETE_TRAFFIC,
                            listDeleteTrafficParam,
                            user
                        );
                        updateListRegist(listDeleteTrafficParam);
                    }
                })
                .then(() => {
                    // 通行量 削除パラメータを初期化
                    dispatch(setTrafficVolumeClearDeleteParam());
                })
                .then(() => {
                    //保存処理後、複製処理
                    duplicate();
                })
                .catch((e) => {
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                    console.log(e);
                });
        } else {
            //複製処理
            duplicate();
        }
    };

    //複製処理
    const duplicate = () => {
        const surveyRequestCheckParams = {
            mode: "regist",
            endPoint: "/location/Task/v1/survey-request-check",
            query: {
                plan_area_id: props.planAreaId,
                branch: props.branch,
                request_type: "0", //通常出力
            },
        };
        const duplicateParams = {
            mode: "regist",
            endPoint: "/location/system/v1/duplicate",
            query: {
                plan_area_id: props.planAreaId,
                branch: props.branch,
                store_code: objLocationBase.child_location,
                type: "1",
            },
        };
        (async () => {
            try {
                //依頼APIチェックを実施
                const resultCheck = await apiRequest(surveyRequestCheckParams);
                if (resultCheck.data.dataList.length > 0) {
                    const dataList = JSON.parse(resultCheck.data.dataList);
                    const resultLocationExcelFlag =
                        dataList.LocationExcelFlag === "0";
                    const resultN15AddMarketFlag =
                        dataList.n15AddMarketFlag === "0";
                    //中間生成物が取り込まれていない場合 「中間生成物が取り込まれていません」のメッセージ表示
                    if (resultLocationExcelFlag && !resultN15AddMarketFlag) {
                        if (utilityCtx.hideSpinner) {
                            utilityCtx.hideSpinner();
                        }
                        setDuplicatePageing("errorLocationExcelFlagAndN15AddMarketFlagCheck");
                        setLocationExcelFlag("0");
                        //n15追加商圏にデータが存在しない場合「n15追加商圏が取り込まれていません」のエラーメッセージを表示
                    } else if (
                        resultN15AddMarketFlag &&
                        !resultLocationExcelFlag
                    ) {
                        if (utilityCtx.hideSpinner) {
                            utilityCtx.hideSpinner();
                        }
                        setDuplicatePageing("errorLocationExcelFlagAndN15AddMarketFlagCheck");
                        setN15AddMarketFlag("0");
                        //中間生成物とn15追加商圏どちらも取り込まれていない場合
                    } else if (
                        resultLocationExcelFlag &&
                        resultN15AddMarketFlag
                    ) {
                        if (utilityCtx.hideSpinner) {
                            utilityCtx.hideSpinner();
                        }
                        setDuplicatePageing("errorLocationExcelFlagAndN15AddMarketFlagCheck");
                        setLocationExcelFlag("0");
                        setN15AddMarketFlag("0");
                        //中間生成物が存在する場合は入力チェック、出力依頼
                    } else {
                        if (dataList.Response === "error") {
                            if (utilityCtx.hideSpinner) {
                                utilityCtx.hideSpinner();
                            }
                            //不正な入力項目を表示
                            setErrorList(dataList.errorList);
                            setDuplicatePageing("errorList");
                        } else if (dataList.Response === "success") {
                            // userLogging
                            userLogging(
                                LOCAL_CONSTANT.FUNCTION_NAME.DUPLICATE,
                                duplicateParams,
                                user
                            );
                            //複製APIを実施
                            const duplicateResultCheck = await apiRequest(
                                duplicateParams
                            );
                            //複製APIのレスポンス取得
                            const duplicateDataList = JSON.parse(
                                duplicateResultCheck.data.dataList
                            );
                            if (utilityCtx.hideSpinner) {
                                utilityCtx.hideSpinner();
                            }
                            if (duplicateDataList.Response === "error") {
                                // 複製でエラーの場合duplicateErrorをセットして終了とする
                                setDuplicatePageing("duplicateError");
                            } else if (
                                duplicateDataList.Response === "success"
                            ) {
                                // 複製で成功の場合、複製のステータスフラグを更新
                                setDuplicatePageing("duplicateComplete");
                                //複製完了後 複製のステータスフラグを更新
                                setDuplicateStatus(true);
                            }
                        }
                    }
                }
            } catch (e) {
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                setDuplicatePageing("duplicateError");
                console.log(e);
            }
        })();
    };

    // 複製ボタン押下後、既存店ボタン use_plan_area_idを取得、出店条件 S店情報の受付NOを取得
    useEffect(() => {
        if (duplicateStatus) {
            try {
                callApiDuplicate("getDuplicate").then((res: any) => {
                    //初期値をDBの値を更新
                    dispatch(
                        setInitLocationBase(
                            locationBaseData(res.getLocationBase)
                        )
                    );
                    //既存店ボタン use_plan_area_idを取得
                    if (res.getExistingSejStoreUsePlanAreaId?.length > 0) {
                        dispatch(
                            setUsePlanAareaId(
                                res.getExistingSejStoreUsePlanAreaId[0]
                                    .use_plan_area_id
                            )
                        );
                    }
                    //出店条件 S店情報 受付NOをアスタリスクなど仮の値からDBの値へ更新
                    dispatch(
                        setObjStoreOpeningConditions({
                            ...objStoreOpeningConditions,
                            reception_no:
                                res.getLocationStoreOpeningConditions[0]
                                    .reception_no,
                        })
                    );
                    //出店条件の初期値をDBの更新
                    dispatch(
                        setInitObjStoreOpeningConditions(
                            storeOpeningConditionsData(
                                res.getLocationStoreOpeningConditions
                            )
                        )
                    );
                });
            } catch (e) {
                console.log(e);
            }
            //複製完了後 複製のステータスフラグを更新
            setDuplicateStatus(false);
        }
    }, [duplicateStatus]);

    //ユーザー取得
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    useEffect(() => {
        // 不備コメントリストからテーブル名を抽出し、重複したテーブル名を削除
        const uniqueTableNames = listDeficiencyComment.reduce(
            (acc: string[], item: any) => {
                if (item &&
                    item.table_name &&
                    // 表紙より上のページはスクロール対象外
                    item.table_name !== LOCAL_CONSTANT.TABLE.BASE &&
                    // 不備ステータスが0,1,2の場合、スクロール対象
                    LOCAL_CONSTANT.DEFICIENCY.STATUS.includes(item.deficiency_status)
                ) {
                    let tableName = item.table_name;
                    // テーブル名とスクロール要素を対応させるため、テーブル名を統一
                    switch (item.table_name) {
                        case LOCAL_CONSTANT.TABLE.CONFLICT_MARKET_CUT:
                            tableName = LOCAL_CONSTANT.TABLE.CONFLICT;
                            break;
                        default:
                            tableName = item.table_name;
                    }
                    if (!acc.includes(tableName)) {
                        acc.push(tableName);
                    }
                }
                return acc;
            },[]
        );
        // 不備コメントのあるページの並び替え
        setDeficiencySortedList(
            uniqueTableNames.sort((a: string, b: string) => {
                return (
                    deficiencyPageOrder.indexOf(a) -
                    deficiencyPageOrder.indexOf(b)
                );
            })
        );
        // クリックカウントををリセット
        setDeficiencyClickCount(0)
    }, [listDeficiencyComment]);

    //不備ページ移動ボタン押下時 
    const handleDeficiencyScroll = () => {
        if (deficiencyClickCount < deficiencySortedList.length) {
            // クリックする度にスクロール
            const currentTableName = deficiencySortedList[deficiencyClickCount];
            const elementId = elementIds[currentTableName];
            const element = document.getElementById(elementId);
            if (element) {
                element.click();
            }
            // 次の要素にスクロールするためにクリックカウントをインクリメント
            setDeficiencyClickCount(deficiencyClickCount + 1);
        } else {
            // 最初の要素にスクロールするように設定
            const firstElementId = elementIds[deficiencySortedList[0]];
            const firstElement = document.getElementById(firstElementId);
            if (firstElement) {
                firstElement.click();
            }
            // 次のクリックで2番目の要素にスクロールするためにクリックカウントを1にリセット
            setDeficiencyClickCount(1);
        }
    };

    return (
        <>
            {/* フロートボタン */}
            <Grid container spacing={2}>
                <Grid item xs={5}></Grid>
                <Grid item xs={7} sx={{ position: "fixed", top: "6%", right: "2%", margin: theme.spacing(2), zIndex: 1000 }}>
                    {HideShowFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.LONG_PAGE, "duplicate") &&
                        (objLocationBase.location_type === "02" || objLocationBase.location_type === "03") &&
                        <Button
                            sx={{
                                margin: "10px 0",
                                marginLeft: "10px",         // FloatButtonと同じ
                            }}
                            variant="contained"
                            color="success"
                            onClick={() => { handleTrafficCheck("dulicate") }}>
                            複製
                        </Button>
                    }
                    {/* 既存店ボタン 調査種別が「セットバック（改造後）」「立地評価（タイプ変更後）」「 S＆B（B店） 」の時に表示 */}
                    {(objLocationBase.location_type === "02" || objLocationBase.location_type === "03" || objLocationBase.location_type === "04") && (
                        <Button
                            sx={{
                                margin: "10px 0",
                                marginLeft: "10px",         // FloatButtonと同じ
                                '&.Mui-disabled': {
                                    opacity: 1, // 透過を無効化
                                    backgroundColor: "#E0E0E0", // 薄いグレー
                                    color: "#9E9E9E",           // 濃いグレー
                                    border: "none",
                                    boxShadow: "none",
                                },
                            }}
                            variant="contained"
                            color="success"
                            disabled={usePlanAareaId === "" ? true : false}
                            onClick={() => { handleOpenNewLocationClick(usePlanAareaId, props.branch) }}>
                            既存店
                        </Button>
                    )}
                    {/* 子調査またはRFCの場合 依頼コメントボタンを非表示 */}
                    {(userType !== LOCAL_CONSTANT.USER_TYPE.RFC && (props.planAreaId?.startsWith("X") || props.planAreaId?.startsWith("Y")) === false) && 
                        <FloatButton variant="outlined" onClick={() => { handleNewTabPage("/RequestComment") }}>依頼/コメント</FloatButton>
                    }
                    {/* 表紙～図面までに不備コメントが1件でもある場合は表示 */}
                    {deficiencySortedList.length > 0 &&
                        <FloatRedButton variant="outlined" onClick={() => { handleDeficiencyScroll() }}>不備ページ移動</FloatRedButton>
                    }
                    <FloatButton variant="outlined" onClick={() => { handleNewTabPage("/DeficiencyComment") }}>{LOCAL_CONSTANT.LABEL.LIST_OF_DEFICIENCIES}</FloatButton>
                    <FloatButton variant="outlined" onClick={() => { handleNewTabPage("/r_view") }}>{LOCAL_CONSTANT.LABEL.R_VIEW}</FloatButton>
                    <FloatButton variant="outlined" onClick={() => { handleNewTabPage("/PdfSummary") }}>{LOCAL_CONSTANT.LABEL.PDF}</FloatButton>
                    <FloatButton variant="outlined" onClick={() => { handleTrafficCheck("save") }} disabled={hasSaveDisabled()}>{LOCAL_CONSTANT.LABEL.SAVE}</FloatButton>
                </Grid>
            </Grid>

            {/* 保存確認モーダル */}
            <Dialog open={saveConfModalOpen} onClose={handleSaveConfModalClose}>
                {pageing === 0 && (
                    <Box>
                        <DialogTitle sx={{ textAlign: "center" }}>入力中の内容を保存しますか？</DialogTitle>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <CancelButton onClick={() => { handleSaveConfModalClose(); }}>キャンセル</CancelButton>
                            </Grid>
                            <Grid item xs={6}>
                                <SaveButton onClick={() => { handleSave(); }}>保存</SaveButton>
                            </Grid>
                        </Grid>
                    </Box>
                )}

                {pageing === 1 && (
                    <Box>
                        <DialogTitle sx={{ textAlign: "center" }}>保存しました。</DialogTitle>
                        <Box sx={{ margin: "30px" }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    <SaveButton onClick={() => { handleSaveConfModalClose(); }}>閉じる</SaveButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                )}

                {pageing === 2 && (
                    <Box>
                        <DialogTitle sx={{ textAlign: "center" }}>保存に失敗しました。</DialogTitle>
                        <Box sx={{ margin: "30px" }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    <CancelButton onClick={() => { handleSaveConfModalClose(); }}>閉じる</CancelButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                )}
            </Dialog>

            {/* 複製確認モーダル */}
            <Dialog
                open={duplicateConfModalOpen}
                sx={{ minWidth: "700px" }}
                onClose={hanldeDuplicateConfModalClose}
            >
                {duplicatePageing === "duplicateConfirm" && (
                    <Box>
                        <DialogTitle sx={{ textAlign: "center" }}>複製を実施しますか？</DialogTitle>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <DuplicateCancelButton onClick={() => { hanldeDuplicateConfModalClose(); }}>キャンセル</DuplicateCancelButton>
                            </Grid>
                            <Grid item xs={6}>
                                <DuplicateButton onClick={() => { handleDuplicate(); }}>はい</DuplicateButton>
                            </Grid>
                        </Grid>
                    </Box>
                )}

                {duplicatePageing === "duplicateComplete" && (
                    <Box>
                        <DialogTitle sx={{ textAlign: "center" }}>複製しました。
                        </DialogTitle>
                        <Box sx={{ margin: "30px" }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    <DuplicateButton onClick={() => { hanldeDuplicateConfModalClose(); }}>閉じる</DuplicateButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                )}

                {duplicatePageing === "duplicateError" && (
                    <Box>
                        <DialogTitle sx={{ textAlign: "center" }}>複製に失敗しました。</DialogTitle>
                        <Box sx={{ margin: "30px" }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    <DuplicateCancelButton onClick={() => { hanldeDuplicateConfModalClose(); }}>閉じる</DuplicateCancelButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                )}

                {duplicatePageing ===
                    "errorLocationExcelFlagAndN15AddMarketFlagCheck" && (
                        //中間生成物とN15追加商圏の判定結果
                        <LocationExcelAndN15AddMarktCheck
                            props={{
                                locationExcelFlag: locationExcelFlag,
                                n15AddMarketFlag: n15AddMarketFlag,
                                handleModalClose: hanldeDuplicateConfModalClose,
                            }}
                        />
                    )}

                {/* エラー項目一覧 */}
                {duplicatePageing === "errorList" && (
                    <InvalidInputList
                        props={{
                            errorMessage:
                                LOCAL_CONSTANT.ERROR_MESSAGE
                                    .ERROR_LOCATION_ITEM,
                            errorList: errorList,
                            handleModalClose: hanldeDuplicateConfModalClose,
                        }}
                    />
                )}
            </Dialog>

            {/* 通行量項目チェックモーダル */}
            <TrafficCheckModal
                props={{
                    checkPoint: "saveAndDulicate",
                    modalOpen: trafficCheckOpen,
                    setModalOpen: setTrafficCheckOpen,
                    handleModalClose: {
                        save: handleSaveConfModalClose,
                        dulicate: hanldeDuplicateConfModalClose
                    }
                }}
            />

        </>
    );
};

export default Menu;
